export const challenges = [
  {
    title: "Your Clinical Information Is Scattered Across Multiple Resources",
    body: [
      "You have accumulated valuable information from courses, reference books, educational events, and personal notes.",
      "But finding a particular topic when you want to review it can take longer than expected.",
    ],
    approach: "Organize related educational topics into a structured reference collection.",
  },
  {
    title: "You Want a More Consistent Patient Assessment Framework",
    body: [
      "Patient assessment involves reviewing multiple factors rather than relying on a single observation.",
      "You want a practical way to organize relevant information, identify questions requiring further evaluation, and document your assessment.",
    ],
    approach: "Use structured educational worksheets to organize the information relevant to patient assessment.",
  },
  {
    title: "You Want to Improve the Organization of Your Clinical Records",
    body: [
      "Patient history, treatment details, photographic documentation, follow-up notes, and unexpected events all require appropriate records.",
      "Keeping your documentation resources organized can make your administrative workflow more consistent.",
    ],
    approach: "Access dedicated templates and documentation worksheets in one collection.",
  },
  {
    title: "You Want to Study Potential Complications More Systematically",
    body: [
      "Understanding potential complications and recognizing concerning clinical presentations are important aspects of professional education.",
      "You want a structured way to revisit relevant concepts and understand when findings may require urgent assessment.",
    ],
    approach: "Study educational references covering complications, warning signs, documentation, and escalation considerations.",
  },
  {
    title: "You Need Practical Resources, Not Just Theoretical Information",
    body: [
      "You don’t necessarily need another collection of disconnected explanations.",
      "You want materials you can review, annotate, and adapt to your professional setting.",
    ],
    approach: "Combine educational volumes with worksheets, checklists, case studies, and reference tables.",
  },
  {
    title: "You Want a Better System for Continuing Professional Education",
    body: [
      "Your professional knowledge develops over time, and your references should be easy to organize and revisit.",
    ],
    approach: "Maintain a dedicated educational library organized around the major topics of facial aesthetic clinical practice.",
  },
];
